/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MenuSectionType extends DaoModel {
  constructor(guid, id, translation, code_name) {
    super(guid);
    this.id = id;
    this.translation = translation;
    this.code_name = code_name;
  }

  static toInstance(props = {}) {
    return new MenuSectionType(props.guid, props.id, props.translation, props.code_name);
  }

  serialize() {
    return {
      ...super.serialize(),
      id: this.id,
      translation: this.translation,
      code_name: this.code_name
    };
  }
}
